<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@commercebear/components/Button';
  import Icon from '@commercebear/components/Icon';
  import Rule from '@commercebear/components/Rule';
  import Menu, { MenuItem } from '@commercebear/components/Menu';
  import { useJobsDialog } from '$lib/components/JobsDialogProvider';
  import OrganizationPicker from '$lib/components/OrganizationPicker';
  import { useCurrentOrganization } from '$providers/CurrentOrganizationProvider';
  import { useAllOrganizations } from '$providers/AllOrganizationsProvider';
  import Auth from '$util/auth';
  import { goto } from '$app/navigation';

  const jobsDialog = useJobsDialog();

  const currentOrganization = useCurrentOrganization();
  const allOrganizations = useAllOrganizations();
  $: hasMultipleOrgs = $allOrganizations.length > 1;

  let anchor;
  let sidebarMenu;
  let orgPicker;
  let orgPickerOpen;

  const dispatch = createEventDispatcher();

  function showSidebarMenu() {
    sidebarMenu.show();
    dispatch('show');
  }
  function dismissSidebarMenu() {
    if (!orgPickerOpen) {
      dispatch('dismiss');
    }
  }
  function showOrgPicker() {
    orgPicker.show();
    orgPickerOpen = true;
  }
  function dismissOrgPicker() {
    orgPickerOpen = false;
    dispatch('dismiss');
  }

  async function logout() {
    await Auth.logout();
    window.location.href = '/';
  }
</script>

<div bind:this={anchor} class='anchor'>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <Button secondary on:click={showSidebarMenu} testid='sidebar-dropdown-button'>
    {$currentOrganization.name}
    <Icon icon='arrow_drop_down'/>
  </Button>
</div>

<Menu
  bind:this={sidebarMenu}
  {anchor}
  gravity='top right'
  initialFocus={false}
  focusOnDismiss={false}
  on:dismiss={dismissSidebarMenu}
  testid='sidebar-dropdown'
>
  <svelte:fragment slot='items' let:list>
    <MenuItem {list} on:click={showOrgPicker} icon='switch_account' disabled={!hasMultipleOrgs} testid='switch-orgs-button'>Switch Organizations</MenuItem>
    <div class='rule'>
      <Rule/>
    </div>
    <MenuItem {list} on:click={() => $jobsDialog?.show()} icon='history' testid='tasks'>History</MenuItem>
    <MenuItem {list} on:click={() => goto('/settings')} icon='settings' testid='settings'>Settings</MenuItem>
    <MenuItem {list} on:click={logout} icon='logout' testid='logout'>Logout</MenuItem>
  </svelte:fragment>
</Menu>

<OrganizationPicker
  bind:this={orgPicker}
  currentOrganization={$currentOrganization}
  allOrganizations={$allOrganizations}
  on:dismiss={dismissOrgPicker}
  {anchor}
/>

<style lang='postcss'>
  .anchor {
    --Button--width: calc(240px - var(--spacing--xl));
	  --Button--justify-content: space-between;
	  --Button--white-space: normal;
	  --Button--text-align: start;
	  --Button--padding: var(--spacing--xs) var(--spacing--xs) var(--spacing--xs) var(--spacing--s);
    --size--control: fit-content;
  }

  .rule {
    padding: 10px 0;
  }
</style>
